export default __webpack_public_path__ + "static/media/tippsy.6096b06d.png";